import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';
import { changeFavoriteAction, fetchAgent } from '../../store/offer';
import { setKeyPushNotificationValue } from '../../store/push_subscription';
import { getParent } from '../../utils/offer_helpers';
import {
  getBookingTracking,
  trackBookingPaymentFailed,
  trackBookingPaymentSucceeded,
} from '../../utils/tracking_booking';
import { IOfferCardPageDispatchProps, IOfferCardPageStoreProps, OfferCardPage } from './OfferCardPage';
import { setHideOfferState, toggleTopPopup, ISetHideOfferInfo } from '../../store/hide_offer';
import { getDynamicCalltrackingSiteBlockId } from '../../selectors/getDynamicCalltrackingSiteBlockId';
import { isNewbuildingSelector, isInRegionSelector } from '../../selectors/offerData/offer';
import { isCountrysideCardIntegrated } from '../../utils/countrysideCardIntegration';
import { isDealRent } from '../../selectors/isDealRent';
import { isDealRentCianAgency } from '../../utils/dealRentCianAgencyExperiment';
import { getDemandExperiment } from '../../utils/newRequestDemandPositionExperiment';
import { isNewDealRentOfferInfoBlock } from '../../utils/newDealRentOfferInfoBlock';
import { dealVersionSelector } from '../../selectors/offerData/offer/dealVersion';

export function mapStateToProps(state: IState): IOfferCardPageStoreProps {
  const {
    offerData,
    isPikBookingSucceeded,
    bookedOfferId,
    experiments,
    abUseExperiments,
    isStalkerBannerShown,
    hideOffer,
    isBrandingAvailable,
    isPravocardEnabled,
    newbuildingConsultant,
  } = state;
  const { agent, degradationInfo, offer, user, isHiddenByUser, tourV2 } = offerData;
  const { consultantPhoneEnabledRegions } = newbuildingConsultant;
  const isNewBuilding = isNewbuildingSelector(state);
  const isDealRentFlag = isDealRent(state);

  return {
    bookedOfferId,
    bookingTracking: getBookingTracking(offer, agent),
    experiments,
    isBrandingAvailable,
    isPravocardEnabled,
    isPikBookingSucceeded,
    degradationInfo,
    offer,
    parent: getParent(state.offerData),
    status: offer.status,
    isUserAuthenticated: user && user.isAuthenticated,
    isStalkerBannerShown,
    hideOfferStatus: hideOffer.status,
    hideOfferErrorMessage: hideOffer.errorMessage,
    isTopPopupOpened: hideOffer.isTopPopupOpened,
    isHiddenByUser,
    isNewBuilding,
    trackBookingPaymentFailed: () => trackBookingPaymentFailed(offer, agent),
    trackBookingPaymentSucceeded: () => trackBookingPaymentSucceeded(offer, agent),
    isCountrysideCardIntegrated: isCountrysideCardIntegrated(state),
    newbuildingDynamicCalltracking: getDynamicCalltrackingSiteBlockId(state),
    hasTour: !!tourV2,
    isDealRentCianAgencyEnabled: Boolean(isDealRentFlag && isDealRentCianAgency(abUseExperiments)),
    requestDemandPosition: getDemandExperiment(abUseExperiments),
    isDealRent: isDealRentFlag,
    showConsultantPhone: isNewBuilding && isInRegionSelector(consultantPhoneEnabledRegions)(state),
    isNewDealRentOfferInfoBlockEnabled: isNewDealRentOfferInfoBlock(abUseExperiments),
    dealVersion: dealVersionSelector(state),
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): IOfferCardPageDispatchProps {
  return {
    fetchAgent: () => dispatch(fetchAgent()),
    saveToFavorite: () => dispatch(changeFavoriteAction(true)),
    setKeyPushNotificationValue: (value: boolean) => dispatch(setKeyPushNotificationValue(value)),
    setHideOfferState: (info: ISetHideOfferInfo) => dispatch(setHideOfferState(info)),
    toggleTopPopup: (isTopPopupOpened: boolean) => dispatch(toggleTopPopup(isTopPopupOpened)),
  };
}

export const OfferCardPageContainer = connect(mapStateToProps, mapDispatchToProps)(OfferCardPage);
